import React from 'react'
import logo from './../../Assets/Images/jaliscoLogo.png'
import loading from './../../Assets/Images/load.svg'

export const LoadingLayer = () => {
  return (
    <div className="container-loading">
      <div className="section-loading">
        <img
          src={logo}
          className="img-logo-full-loading-layer"
          alt="iconapp"
          style={{ filter: 'brightness(0) invert(1)' }}
        />
        <img src={loading} className="img-loading" alt="loading" style={{ filter: 'brightness(0) invert(1)' }} />
      </div>
    </div>
  )
}
export default LoadingLayer
